/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, CarFromJSON, CarToJSON, CarTireFromJSON, CarTireToJSON, TireSeasonTypeFromJSON, TireSeasonTypeToJSON, } from './';
export function CarSeasonTireFromJSON(json) {
    return CarSeasonTireFromJSONTyped(json, false);
}
export function CarSeasonTireFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'seasonType': !exists(json, 'seasonType') ? undefined : TireSeasonTypeFromJSON(json['seasonType']),
        'seasonTires': !exists(json, 'seasonTires') ? undefined : (json['seasonTires'] === null ? null : json['seasonTires'].map(CarTireFromJSON)),
        'hasRim': !exists(json, 'hasRim') ? undefined : json['hasRim'],
    };
}
export function CarSeasonTireToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'car': CarToJSON(value.car),
        'carId': value.carId,
        'seasonType': TireSeasonTypeToJSON(value.seasonType),
        'seasonTires': value.seasonTires === undefined ? undefined : (value.seasonTires === null ? null : value.seasonTires.map(CarTireToJSON)),
        'hasRim': value.hasRim,
    };
}
